class CustomServiceCard extends HTMLElement {
    connectedCallback() {
        const title = this.getAttribute('title') || 'Service';
        const icon = this.getAttribute('icon') || 'star';
        const description = this.getAttribute('description') || 'Premium cleaning service.';
        
        this.attachShadow({ mode: 'open' });
        this.shadowRoot.innerHTML = `
            <style>
                :host {
                    display: block;
                    background: white;
                    border-radius: 0.5rem;
                    overflow: hidden;
                    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
                    transition: transform 0.3s, box-shadow 0.3s;
                }
                :host(:hover) {
                    transform: translateY(-4px);
                    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
                }
                .card-content {
                    padding: 1.5rem;
                    height: 100%;
                }
                .icon-container {
                    width: 3rem;
                    height: 3rem;
                    border-radius: 50%;
                    background-color: #f8e8e8;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-bottom: 1rem;
                }
                .icon {
                    color: #981010;
                    width: 1.5rem;
                    height: 1.5rem;
                }
                .title {
                    font-family: 'Playfair Display', serif;
                    font-size: 1.25rem;
                    font-weight: 600;
                    margin-bottom: 0.75rem;
                    color: #1e293b;
                }
                .description {
                    color: #64748b;
                    margin-bottom: 1.5rem;
                    line-height: 1.5;
                }
                .btn {
                    display: inline-block;
                    padding: 0.5rem 1rem;
                    background-color: #f8e8e8;
                    color: #981010;
                    border-radius: 0.25rem;
                    font-weight: 500;
                    text-decoration: none;
                    transition: background-color 0.3s;
                }
                .btn:hover {
                    background-color: #e8c4c4;
                }
            </style>
            <div class="card-content">
                <div class="icon-container">
                    <i data-feather="${icon}" class="icon"></i>
                </div>
                <h3 class="title">${title}</h3>
                <p class="description">${description}</p>
                <a href="/#booking-section" class="btn">Book Now</a>
</div>
        `;
    }
}
customElements.define('custom-service-card', CustomServiceCard);